import React, { useState } from "react";

//
import { Modal, Button } from "react-bootstrap";

//
import Telegram from "../../assets/img/telegram-2.png";
import Step1 from "../../assets/img/telegram-steps/step-1.png";
import Step2 from "../../assets/img/telegram-steps/step-2.png";
import Step3 from "../../assets/img/telegram-steps/step-3.png";

function FearGreedQuestion() {
  const [show, setShow] = useState(false);
  return (
    <>
      <a className="outer-link pointer" onClick={() => setShow(true)}>
        Learn more
        <i className="las la-arrow-up"></i>
      </a>

      <Modal
        size="xl"
        id="learn-more-modal"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <div style={{ backgroundImage: `url(${Telegram})` }}>
            <h3>Want to receive Invalert signals in form of private messages on Telegram?</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <article>
            <div className="paragraph">
              <h5>Step 1:</h5>
              <p>
                To begin, login to your account and click on “Private telegram
                channel” from the dashboard
              </p>
              <img
                src={Step1}
                alt="step-1"
                className="img-fluid d-block mx-auto"
              />
            </div>

            <div className="paragraph">
              <h5>Step 2:</h5>
              <p>
                Next, click on “Connect” to proceed to an initial telegram link.
                If you have previously connected your telegram, you can change
                or disconnect the account here.
              </p>
              <img
                src={Step2}
                alt="step2"
                className="img-fluid d-block mx-auto"
              />
            </div>

            <div className="paragraph">
              <h5>Step 3:</h5>
              <p>
                Finally, click on the Iinvalertbot hyperlink (blue) or scan the
                QR code to be redirected to the Telegram messaging app. Send the
                provided code to our personalized messaging bot and you are all
                set to receive our state of the art trading signals!
              </p>
              <img
                src={Step3}
                alt="step2"
                className="img-fluid d-block mx-auto"
              />
            </div>
          </article>

          <Button
            className="close-modal"
            variant="white"
            size="lg"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default FearGreedQuestion;
